import { runCommand } from './shell/index.js';

export function isInsideGitRepo(cwd: string) {
  return runCommand('git rev-parse --is-inside-work-tree', { cwd })
    .then(() => true)
    .catch(() => false);
}

export async function getGitRoot(cwd: string) {
  return runCommand('git rev-parse --show-toplevel', { cwd });
}

export async function getGitLatestCommitHash(cwd: string) {
  try {
    return await runCommand('git rev-parse --verify HEAD', { cwd });
  } catch {
    // This command can fail if there are no commits, so we can just return undefined
  }
}

export async function gitInit(cwd: string) {
  await runCommand('git init', { cwd });
}

export async function gitCommit(cwd: string) {
  await runCommand('git add -A', { cwd });
  await runCommand(
    `git commit -m Initial\\ commit\\ from\\ Create\\ Wix\\ App --no-verify`,
    { cwd }
  );
}

export async function gitClone(url: string, path: string) {
  await runCommand(`git clone --depth 1 ${url} ${path}`, {
    env: {
      /*
       * This is to prevent git from prompting for credentials.
       * `git clone` uses a subprocess for the authentication, so we can't attach the main process to its stdio.
       * This leads to:
       *  - the spinners "swallow" its output.
       *  - after answering with the username and pressing "Enter", the first line of the output is being duplicated.
       * That's why we're disabling the prompt, so user should be pre-authenticated.
       */
      GIT_TERMINAL_PROMPT: '0',
    },
  });
}
